import styled from 'styled-components'
import { spacing } from '@chegg-ui/theme'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { SpecialButtonLink } from '@chegg-wt/core/theme/fanta/button'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Heading2, BodyLightGray } from '@chegg-wt/core/theme/sunkist/typography'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 30px 0;
  @media (max-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    align-items: flex-start;
    flex-direction: column;
    margin-left: ${values.small};
  }
`

export const Img = styled.img`
  width: 100%;
  height: auto;
  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    width: 500px;
    height: 300px;
  }
`

export const Info = styled.div`
  margin: ${values.small};
  @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    width: 300px;
  }
`

export const Header = styled.h2`
  ${Heading2};
  margin-bottom: ${values.small};
`

export const Context = styled.p`
  ${BodyLightGray};
`

export const RedirectButton = styled(SpecialButtonLink)`
  margin-top: ${spacing.px4};
`
